// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58071047","453":"5c693aa0","455":"ea12f4f0","977":"fbdaa94a"}[chunkId] + ".chunk.js";
};